import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    afipCodigoPais: 0,
    afipCuitPais: 0,
    inactivo: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, paisId) {
        state.id = paisId;
        state.nombre = '';
        state.afipCodigoPais = 0;
        state.afipCuitPais = 0;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_PAIS'(state, pais) {
        state.nombre = pais.nombre.toUpperCase().trim();
        state.afipCodigoPais = pais.afipCodigoPais;
        state.afipCuitPais = pais.afipCuitPais;
        state.inactivo = pais.inactivo;
        state.rowVersion = pais.rowVersion;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, paisId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', paisId);

            if (paisId != 0) {
                apiAxios.get('paises/' + paisId + '/abm' ) 
                .then(res => {
                    commit('SET_PAIS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let pais = {
                nombre: state.nombre.toUpperCase().trim(),
                afipCodigoPais: state.afipCodigoPais,
                afipCuitPais: state.afipCuitPais,
                inactivo: state.inactivo,
            }

            let url = 'paises';
            if (state.id != 0) {
                url += '/' + state.id;
                pais.rowVersion = state.rowVersion;
            }
            
            apiAxios.post(url, pais)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}